export default function checkCartServices({ store, redirect }) {
  if (store.getters['cart/getCartAllItemsCount'].services === 0) {
    return redirect({ name: 'cart' });
  }
}
